import { useState } from 'react';
import { BoPhan, NhomPhi, Phi, PhiBoPhanData, PhiGroupData } from '@/types/schemas';

export interface FormState {
  nhomPhi1: NhomPhi | PhiGroupData | null;
  nhomPhi2: NhomPhi | PhiGroupData | null;
  nhomPhi3: NhomPhi | PhiGroupData | null;
  boPhan: BoPhan | PhiBoPhanData | null;
}

export interface FormActions {
  setNhomPhi1: (nhomPhi1: NhomPhi) => void;
  setNhomPhi2: (nhomPhi2: NhomPhi) => void;
  setNhomPhi3: (nhomPhi3: NhomPhi) => void;
  setBoPhan: (boPhan: BoPhan) => void;
  resetState: () => void;
  updateState: (updates: Partial<FormState>) => void;
}

export interface UseFormStateReturn {
  state: FormState;
  actions: FormActions;
}

const initialState: FormState = {
  nhomPhi1: null,
  nhomPhi2: null,
  nhomPhi3: null,
  boPhan: null
};

function transformInitialData(initialData?: Phi): Partial<FormState> {
  if (!initialData) return {};

  return {
    nhomPhi1: initialData.nhom_phi_1_data || null,
    nhomPhi2: initialData.nhom_phi_2_data || null,
    nhomPhi3: initialData.nhom_phi_3_data || null,
    boPhan: initialData.bo_phan_data || null
  };
}

export function useFormState(initialData?: Phi): UseFormStateReturn {
  const [state, setState] = useState<FormState>({
    ...initialState,
    ...transformInitialData(initialData)
  });

  const actions: FormActions = {
    setNhomPhi1: (nhomPhi1: NhomPhi) => {
      setState(prev => ({ ...prev, nhomPhi1 }));
    },

    setNhomPhi2: (nhomPhi2: NhomPhi) => {
      setState(prev => ({ ...prev, nhomPhi2 }));
    },

    setNhomPhi3: (nhomPhi3: NhomPhi) => {
      setState(prev => ({ ...prev, nhomPhi3 }));
    },

    setBoPhan: (boPhan: BoPhan) => {
      setState(prev => ({ ...prev, boPhan }));
    },

    resetState: () => {
      setState(initialState);
    },

    updateState: (updates: Partial<FormState>) => {
      setState(prev => ({ ...prev, ...updates }));
    }
  };

  return { state, actions };
}
